import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'extended-dropdown',
    template: require('./extended-dropdown.template.html'),
    styles: ['input[type=text] { margin-top:10px; }']
})
export class ExtendedDropDownComponent {
    private selectedItemValue: any = null;
    private newItemNameValue: string;

    get selectedItem() {
        return this.selectedItemValue;
    }
    set selectedItem(val: any) {
        this.selectedItemValue = val;
        if (val == this.newValue) {
            this.selectedItemChange.emit(null);
        } else {
            this.selectedItemValue = this.nullValue;
            this.selectedItemChange.emit(val);
        }
    }
    get newItemName() {
        return this.newItemNameValue;
    }
    set newItemName(val: string) {
        this.newItemNameValue = val;
        this.selectedItemChange.emit(val);
    }
    @Input("items") set itemsBinding(val: any) {
        if (val instanceof Promise) {
            this.isLoadingItems = true;
            val.then(items => {
                this.items = items;
                this.isLoadingItems = false;
            });
        } else {
            this.items = val;
        }
    }
    @Input("selectedItem") set selectedItemBinding(val: any) {
        if (typeof val == "undefined") {
            this.selectedItemValue = this.nullValue;
            return;
        }
        if (typeof val === "string") {
            this.selectedItemValue = this.newValue;
            this.newItemNameValue = val;
        } else if (val) {
            this.selectedItemValue = val;
        }
    }
    @Output("selectedItemChange") selectedItemChange = new EventEmitter();

    nullValue = { val: 'null' };
    newValue = { val: 'new' };
    isLoadingItems: boolean;
    items: any[];
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/extended-dropdown.component.ts